import SubCondition from "./SubCondition";
import React, { useContext } from "react";
import { RulesContext } from "../../RulesContext";
import { AddIconWithBorder } from "assests/GmsIcons";

const Condition = ({ element, position, DragHandle, rule, rootPosition }) => {
  const { ruleDispatch, ruleState } = useContext(RulesContext);
  return (
    <div className="tw-rounded-lg border border-[#E4E4E8] tw-bg-[#FAFAFC] tw-py-6 tw-px-2">
      <span className="drag-icon">{rule.length > 1 && <DragHandle />}</span>
      <div className="">
        <SubCondition {...{ element, position, rule,}} />
        <button className="tw-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-text-[#0747A6] tw-rounded-md hover:tw-bg-blue-50"
          onClick={() => { ruleDispatch({ type: "ADD_NESTED_CONDITION", position: position,});}}>
          <AddIconWithBorder />
          <span className="tw-text-[#0747A6] tw-text-sm">Add Condition</span>
      </button>
      </div>
    </div>
  );
};
export default Condition;